import DocumentSigningContainer from "./DocumentSigningContainer";
import DocumentSigningStore from "./DocumentSigningStore";

export default DocumentSigningStore(DocumentSigningContainer);